import React, { lazy, Suspense } from 'react';
import { FieldLoader } from '@common-ui-library/atom';
import { useUserManagementStore } from '../Store/useUserManagementStore';
import { useShallow } from 'zustand/react/shallow';

const AddNewEntityModal = lazy(() => import('./AddNewEntityModal'));
const DetailsCardComponent = lazy(() => import('./DetailsCard'));

const UMEntityDialog = () => {
  const { selectedItem, isAddEntityOpen } = useUserManagementStore(
    useShallow((state) => ({
      selectedItem: state.selectedItem,
      isAddEntityOpen: state.isAddEntityOpen,
    }))
  );
  return (
    <>
      {selectedItem && !isAddEntityOpen && (
        <Suspense
          fallback={
            <FieldLoader
              sxProps={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
              }}
            />
          }
        >
          <DetailsCardComponent />
        </Suspense>
      )}
      {isAddEntityOpen && (
        <Suspense
          fallback={
            <FieldLoader
              sxProps={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
              }}
            />
          }
        >
          <AddNewEntityModal />
        </Suspense>
      )}
    </>
  );
};

export default UMEntityDialog;
